import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap";
import { toast } from "react-toastify";
import Flatpickr from "react-flatpickr";
import { useFormik } from "formik";
import * as Yup from "yup";
import { digitRegex, InputPlaceHolder, SelectPlaceHolder, validationMessages } from "../../utils/helpers/validationMasseges";
import {
  addConfiguration,
  addResource,
  editConfiguration,
  listOfConfiguration,
  vendorList,
} from "../../api/resourcesApi";
import BreadCrumb from "../../components/common/breadCrumb";
import { getId } from "../../utils/helpers/custom";
import { BrandName, OsType, PaymentModeOption, ResourceType, ResponseStatusEnum, StorageTypeOption } from "../../utils/helpers/enums";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/common/loader";
import { checkStatusCodeSuccess, CommonLabel } from "../../utils/helpers/common";
import { ResourceLabel, Resources } from "../../common/constant/Resource";
import BaseButton from "../../components/BaseComponents/BaseButton";
import { BaseSelect } from "../../components/BaseComponents/BaseSelect";
import BaseInput from "../../components/BaseComponents/BaseInput";

const AddEditConfiguration = () => {
  const [vendor, setVendor] = useState([]);
  const [checkResource, setCheckResource] = useState();
  const [loading, setLoading] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [pageTitle, setPageTitle] = useState();
  const { configurationId } = useParams();
  const [configurationData, setConfigurationData] = useState([]);
  const [selectedOsType, setSelectedOsType] = useState();
  const [selectedViewStorageType, setSelectedViewStorageType] = useState();
  const profileId = getId();
  const navigate = useNavigate();
  const regexSIFormat = /^SI-\d{2}-\d{2}$/;

  useEffect(() => {
    if (!isNaN(configurationId)) {
      setLoading(true);
      setPageTitle(ResourceLabel.EditConfiguration);
      listOfConfiguration({
        id: configurationId,
      })
        .then((resp) => {
          setConfigurationData(resp?.data?.data?.[0]);
          setCheckResource(resp?.data?.data?.[0]?.resourceName);
          setSelectedOsType({
            label: resp?.data?.data?.[0]?.resourceConfiguration?.osType,
            value: resp?.data?.data?.[0]?.resourceConfiguration?.osType,
          });
          setSelectedViewStorageType({
            label: resp?.data?.data?.[0]?.resourceConfiguration?.storageType,
            value: resp?.data?.data?.[0]?.resourceConfiguration?.storageType,
          });
        })
        .catch((err) => err)
        .finally(() => {
          setLoading(false);
        });
    } else {
      setPageTitle(ResourceLabel.AddConfiguration);
    }
    lisOfVendor();
  }, []);

  const lisOfVendor = () => {
    vendorList().then((resp) => {
      setVendor(resp?.data?.data?.map((status) => ({
        value: status?.id,
        label: status?.business,
      })));
    });
  };

  const laptopValidation = {
    pcmodal:
      Yup.string().required(validationMessages.required(ResourceLabel.PCModalName)),
    serialNo:
      Yup.string().required(validationMessages.required(ResourceLabel.PCSerialNo)),
    processor:
      Yup.string().required(validationMessages.required(ResourceLabel.Processor)),
    storagetype:
      Yup.string().required(validationMessages.required(ResourceLabel.StorageType)),
    osVersion:
      Yup.string().required(validationMessages.required(ResourceLabel.OsVersion)),
    warrantyStartDate:
      Yup.string().required(validationMessages.required(ResourceLabel.WarrantyStartDate)),
    warrantyEndDate: Yup.string().when(
      ["checkResource", "warrantyStartDate"],
      {
        is: (warrantyStartDate) =>
          warrantyStartDate,
        then: Yup.string()
          .test(
            "date-comparison",
            ResourceLabel.EndDateValidation,
            function (value) {
              const endDate = this.resolve(Yup.ref("warrantyEndDate"));
              if (endDate && value) {
                return new Date(value) >= new Date(endDate);
              }
              return true;
            }
          )
          .required(validationMessages.required(ResourceLabel.WarrantyEndDate)),
        otherwise: Yup.string().required(validationMessages.required(ResourceLabel.WarrantyEndDate)),
      }
    ),
    ram:
      Yup.string().required(validationMessages.required(ResourceLabel.Ram)),
    osType:
      Yup.string().required(validationMessages.required(ResourceLabel.OsType)),
    graphicCard:
      Yup.string().required(validationMessages.required(ResourceLabel.GraphicCard)),
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      resourceName: configurationData?.resourceName || "",
      allocatedNumber: configurationData?.resourceNo || "",
      amount: configurationData?.amount || "",
      paidby: configurationData?.paidBy || "",
      vendor: configurationData?.vendor?.id || "",
      purchaseDate: configurationData?.purchaseDate || "",
      brandName: configurationData?.brand || "",
      pcmodal: configurationData?.resourceConfiguration?.modelName || "",
      serialNo: configurationData?.resourceConfiguration?.serialNo || "",
      processor: configurationData?.resourceConfiguration?.processor || "",
      storagetype: configurationData?.resourceConfiguration?.storageType || "",
      osVersion: configurationData?.resourceConfiguration?.osVersion || "",
      warrantyStartDate:
        configurationData?.warrantyStartDate || "",
      warrantyEndDate:
        configurationData?.warrantyEndDate || "",
      ram: configurationData?.resourceConfiguration?.RAM || "",
      osType: configurationData?.resourceConfiguration?.osType || "",
      graphicCard: configurationData?.resourceConfiguration?.graphicsCard || "",
    },
    validationSchema: Yup.object({
      resourceName: Yup.string().required(validationMessages.required(ResourceLabel.Resource)),
      brandName: Yup.string().required(validationMessages.required(ResourceLabel.BrandName)),
      allocatedNumber: Yup.string()
        .required(validationMessages.required(ResourceLabel.AllocatedNumber))
        .matches(regexSIFormat, ResourceLabel.AllocatedNumberFormat),
      amount: Yup.string()
        .required(validationMessages.required(ResourceLabel.Amount)),
      paidby: Yup.string().required(validationMessages.required(ResourceLabel.PaymentMode)),
      vendor: Yup.string().required(validationMessages.required(ResourceLabel.Vendor)),
      purchaseDate: Yup.string().required(validationMessages.required(ResourceLabel.PurchaseDate)),
      ...(checkResource === Resources.Laptop ? laptopValidation : {}),
    }),
    onSubmit: (values) => {
      setBtnLoader(true);
      if (!isNaN(configurationId)) {

        let payload = {}
        if(values?.resourceName === Resources.Laptop) {
        payload = {
          addedBy: profileId,
          userId: profileId,
           resourceName: values.resourceName,
           resourceNo: values.allocatedNumber,
           amount: values.amount,
           paidBy: values.paidby,
           brand: values.brandName,
           vendorId: values.vendor,
           purchaseDate: values.purchaseDate,
           serialNo: values.serialNo,
           vendor: values.vendor,
           modelName: values.pcmodal,
           processor: values.processor,
           RAM: values.ram,
           storageType: values.storagetype,
           osType: values.osType,
           osVersion: values.osVersion,
           graphicsCard: values.graphicCard,
           warrantyStartDate: values.warrantyStartDate,
           warrantyEndDate: values.warrantyEndDate,
         }
       } else {
         payload = {
           resourceName: values.resourceName,
           resourceNo: values.allocatedNumber,
           amount: values.amount,
           paidBy: values.paidby,
           brand: values.brandName,
           vendorId: values.vendor,
           purchaseDate: values.purchaseDate,
         }
       }

        editConfiguration(configurationId, payload)
          .then((resp) => {
            if (checkStatusCodeSuccess(resp.data.statusCode)) {
              toast.success(resp.data.message);
            } else {
              toast.error(resp.data.message);
            }
          })
          .catch((err) => err)
          .finally(() => {
            setBtnLoader(false);
            navigate(`/configuration`);
          });
      } else {
        let payload = {}
        if(values?.resourceName === Resources.Laptop) {
         payload = {
           addedBy: profileId,
           userId: profileId,
            resourceName: values.resourceName,
            resourceNo: values.allocatedNumber,
            amount: parseInt(values.amount),
            paidBy: values.paidby,
            brand: values.brandName,
            vendorId: values.vendor,
            purchaseDate: values.purchaseDate,
            serialNo: values.serialNo,
            vendor: values.vendor,
            modelName: values.pcmodal,
            processor: values.processor,
            RAM: values.ram,
            storageType: values.storagetype,
            osType: values.osType,
            osVersion: values.osVersion,
            graphicsCard: values.graphicCard,
            warrantyStartDate: values.warrantyStartDate,
            warrantyEndDate: values.warrantyEndDate,
          }
        } else {
          payload = {
            userId: profileId,
            addedBy: profileId,
            resourceName: values.resourceName,
            resourceNo: values.allocatedNumber,
            amount: parseInt(values.amount),
            paidBy: values.paidby,
            brand: values.brandName,
            vendorId: values.vendor,
            purchaseDate: values.purchaseDate,
          }
        }
        addResource(payload)
          .then((resp) => {
            if (
              checkStatusCodeSuccess(resp?.data?.statusCode) 
            ) {
              toast.success(resp?.data?.message);
              navigate(`/configuration`);
            } else {
              toast.error(resp?.data?.message);
            }
          })
          .catch((err) => err)
          .finally(() => {
            setBtnLoader(false);
          });
      }
    },
  });

  document.title = pageTitle;
  return (
    <div className="page-content">
      {loading && <Loader />}
        <Container fluid>
          <BreadCrumb title={pageTitle} pageTitle="HRMS" />
          <Row className="mb-2">
            <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
              <h5 className="fw-semibold mt-2">{pageTitle}</h5>
            </div>
            <div className="col-auto order-2 order-sm-3 ms-auto">
              <div className="hstack gap-2">
                <Link to="/configuration">
                  <BaseButton
                    color="primary"
                    type="button"
                  >
                    {CommonLabel.Back}
                  </BaseButton>
                </Link>
              </div>
            </div>
          </Row>
          <Card>
            <CardBody>
              <Form
                id="creattask-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row className="g-2 mb-3">
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseSelect
                        name="brandName"
                        label={ResourceLabel.BrandName}
                        placeholder={SelectPlaceHolder(ResourceLabel.BrandName)}
                        options={BrandName}
                        value={validation.values.brandName}
                        handleChange={(field, value) => {
                          validation.setFieldValue(field, value);
                        }}
                        handleBlur={validation.handleBlur}
                        touched={validation.touched.brandName}
                        error={validation.errors.brandName}
                        required={true}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <div className="mb-3">
                        <BaseSelect
                          name="resourceName"
                          label={ResourceLabel.ResourceName}
                          placeholder={SelectPlaceHolder(
                            ResourceLabel.ResourceName
                          )}
                          options={ResourceType}
                          value={validation.values.resourceName}
                          handleChange={(field, value) => {
                            validation.setFieldValue(field, value);
                            setCheckResource(value);
                          }}
                          handleBlur={validation.handleBlur}
                          touched={validation.touched.resourceName}
                          error={validation.errors.resourceName}
                          required={true}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseInput
                        name="allocatedNumber"
                        type="text"
                        label={ResourceLabel.AllocatedNumber}
                        placeholder={InputPlaceHolder(ResourceLabel.AllocatedNumber)}
                        onChange={validation.handleChange}
                        handleBlur={validation.handleBlur}
                        value={validation.values.allocatedNumber}
                        touched={validation.touched.allocatedNumber}
                        error={validation.errors.allocatedNumber}
                        required={true}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseInput
                        name="amount"
                        type="text"
                        label={ResourceLabel.Amount}
                        placeholder={InputPlaceHolder(ResourceLabel.Amount)}
                        onChange={(e) => {
                          if (digitRegex.test(e.target.value)) {
                          validation.handleChange(e);
                          }
                        }}
                        handleBlur={validation.handleBlur}
                        value={validation.values.amount}
                        maxLength={6}
                        touched={validation.touched.amount}
                        error={validation.errors.amount}
                        required={true}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <BaseSelect
                      name="paidby"
                      label={ResourceLabel.PaymentMode}
                      placeholder={SelectPlaceHolder(ResourceLabel.PaymentMode)}
                      options={PaymentModeOption}
                      value={validation.values.paidby}
                      handleChange={(field, value) => {
                        validation.setFieldValue(field, value ? value : null);
                      }}
                      handleBlur={validation.handleBlur}
                      touched={validation.touched.paidby}
                      error={validation.errors.paidby}
                      required={true}
                    />
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseSelect
                        name="vendor"
                        label={ResourceLabel.Vendor}
                        placeholder={SelectPlaceHolder(ResourceLabel.Vendor)}
                        options={vendor}
                        value={validation.values.vendor}
                        handleChange={(field, value) => {
                          validation.setFieldValue(field, value ? value : null);
                        }}
                        handleBlur={validation.handleBlur}
                        touched={validation.touched.vendor}
                        error={validation.errors.vendor}
                        required={true}
                      />
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="mb-3">
                      <Label htmlFor="JoiningdatInput" className="form-label required">
                        {ResourceLabel.PurchaseDate}
                      </Label>
                      <Flatpickr
                        className={`form-select ${
                          validation.errors.purchaseDate && "is-invalid"
                        }`}
                        id="datepicker-publish-input"
                        placeholder={SelectPlaceHolder(ResourceLabel.PurchaseDate)}
                        name="purchaseDate"
                        validate={{ required: { value: true } }}
                        onBlur={validation.handleBlur}
                        value={validation.values.purchaseDate}
                        invalid={
                          !!(
                            validation.touched.purchaseDate &&
                            validation.errors.purchaseDate
                          )
                        }
                        options={{
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: "Y-m-d",
                          maxDate: "today",
                          onChange: function (
                            selectedDates,
                            dateStr,
                            instance
                          ) {
                            validation.setFieldValue("purchaseDate", dateStr);
                          },
                        }}
                      />
                      <div className="invalid-feedback">
                        {validation.errors.purchaseDate}
                      </div>
                    </div>
                  </Col>
                </Row>
                {checkResource === Resources.Laptop && (
                  <>
                    <h4>
                      {!isNaN(configurationId)
                        ? CommonLabel.Update
                        : CommonLabel.Add}
                      {ResourceLabel.LaptopDetail}
                    </h4>
                    <hr />
                    <Row className="g-2 mb-3 mt-4">
                      <Col lg={6}>
                        <div className="">
                          <BaseInput
                            name="pcmodal"
                            type="text"
                            label={ResourceLabel.PCModalName}
                            placeholder={InputPlaceHolder(ResourceLabel.PCModalName)}
                            onChange={validation.handleChange}
                            handleBlur={validation.handleBlur}
                            value={validation.values.pcmodal}
                            touched={validation.touched.pcmodal}
                            error={validation.errors.pcmodal}
                            required={true}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="">
                          <BaseInput
                            name="serialNo"
                            type="text"
                            label={ResourceLabel.PCSerialNo}
                            placeholder={InputPlaceHolder(ResourceLabel.PCSerialNo)}
                            onChange={validation.handleChange}
                            handleBlur={validation.handleBlur}
                            value={validation.values.serialNo}
                            touched={validation.touched.serialNo}
                            error={validation.errors.serialNo}
                            required={true}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="">
                          <BaseInput
                            name="processor"
                            type="text"
                            label={ResourceLabel.Processor}
                            placeholder={InputPlaceHolder(ResourceLabel.Processor)}
                            onChange={validation.handleChange}
                            handleBlur={validation.handleBlur}
                            value={validation.values.processor}
                            touched={validation.touched.processor}
                            error={validation.errors.processor}
                            required={true}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div>
                          <BaseInput
                            name="ram"
                            type="text"
                            label={ResourceLabel.Ram}
                            placeholder={InputPlaceHolder(ResourceLabel.Ram)}
                            onChange={validation.handleChange}
                            handleBlur={validation.handleBlur}
                            value={validation.values.ram || ""}
                            touched={validation.touched.ram}
                            error={validation.errors.ram}
                            required={true}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="">
                          <BaseSelect
                            name="storagetype"
                            label={ResourceLabel.StorageType}
                            placeholder={SelectPlaceHolder(ResourceLabel.StorageType)}
                            options={StorageTypeOption}
                            value={selectedViewStorageType}
                            handleChange={(field, value) => {
                              validation.setFieldValue(field, value);
                            }}
                            handleBlur={validation.handleBlur}
                            touched={validation.touched.storagetype}
                            error={validation.errors.storagetype}
                            required={true}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div>
                          <BaseSelect
                            name="osType"
                            label={ResourceLabel.OsType}
                            placeholder={SelectPlaceHolder(ResourceLabel.OsType)}
                            options={OsType}
                            value={selectedOsType}
                            handleChange={(field, value) => {
                              validation.setFieldValue(
                                field,
                                value ? value : null
                              );
                            }}
                            handleBlur={validation.handleBlur}
                            touched={validation.touched.osType}
                            error={validation.errors.osType}
                            required={true}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div>
                          <BaseInput
                            name="osVersion"
                            type="text"
                            label={ResourceLabel.OsVersion}
                            placeholder={InputPlaceHolder(ResourceLabel.OsVersion)}
                            onChange={validation.handleChange}
                            handleBlur={validation.handleBlur}
                            value={validation.values.osVersion}
                            touched={validation.touched.osVersion}
                            error={validation.errors.osVersion}
                            required={true}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div>
                          <BaseInput
                            name="graphicCard"
                            type="text"
                            label={ResourceLabel.GraphicCard}
                            placeholder={InputPlaceHolder(ResourceLabel.GraphicCard)}
                            onChange={validation.handleChange}
                            handleBlur={validation.handleBlur}
                            value={validation.values.graphicCard || ""}
                            touched={validation.touched.graphicCard}
                            error={validation.errors.graphicCard}
                            required={true}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div>
                          <label
                            htmlFor="task-title-input"
                            className="form-label required"
                          >
                            {ResourceLabel.WarrantyStartDate}
                          </label>
                          <Flatpickr
                            name="warrantyStartDate"
                            id="date-field"
                            className={`form-select ${
                              validation.errors.warrantyStartDate &&
                              "is-invalid"
                            }`}
                            placeholder={SelectPlaceHolder(ResourceLabel.WarrantyStartDate)}
                            invalid={
                              !!(
                                validation.touched.warrantyStartDate &&
                                validation.errors.warrantyStartDate
                              )
                            }
                            value={validation.values.warrantyStartDate || ""}
                            options={{
                              altInput: true,
                              altFormat: "F j, Y",
                              dateFormat: "Y-m-d",
                              onChange: function (
                                selectedDates,
                                dateStr,
                                instance
                              ) {
                                validation.setFieldValue(
                                  "warrantyStartDate",
                                  dateStr
                                );
                              },
                            }}
                          />
                          <div className="invalid-feedback">
                            {validation.errors.warrantyStartDate}
                          </div>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div>
                          <label
                            htmlFor="task-title-input"
                            className="form-label required"
                          >
                            {ResourceLabel.WarrantyEndDate}
                          </label>
                          <Flatpickr
                            name="warrantyEndDate"
                            id="date-field"
                            className={`form-select ${
                              validation.errors.warrantyEndDate &&
                              validation.touched.warrantyEndDate
                                ? "is-invalid"
                                : ""
                            }`}
                            placeholder={SelectPlaceHolder(ResourceLabel.WarrantyEndDate)}
                            value={validation?.values?.warrantyEndDate || ""}
                            invalid={
                              validation.touched.warrantyEndDate &&
                              validation.errors.warrantyEndDate
                            }
                            options={{
                              altInput: true,
                              altFormat: "F j, Y",
                              dateFormat: "Y-m-d",
                              onChange: function (
                                selectedDates,
                                dateStr,
                                instance
                              ) {
                                validation.setFieldValue(
                                  "warrantyEndDate",
                                  dateStr
                                );
                                validation.setFieldTouched(
                                  "warrantyEndDate",
                                  true,
                                  false
                                );
                              },
                              disable: [
                                function (date) {
                                  const startDate = new Date(
                                    validation.values.warrantyStartDate
                                  );
                                  return date < startDate;
                                },
                              ],
                            }}
                          />
                          {validation.touched.warrantyEndDate &&
                            validation.errors.warrantyEndDate && (
                              <div className="invalid-feedback">
                                {validation.errors.warrantyEndDate}
                              </div>
                            )}
                        </div>
                      </Col>
                    </Row>
                  </>
                )}

                <div className="hstack gap-2 justify-content-end">
                  <BaseButton type="submit" color="primary" loader={btnLoader}>
                    {configurationId ? CommonLabel.Update : CommonLabel.Submit}
                  </BaseButton>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
    </div>
  );
};

export default AddEditConfiguration;
